export default __webpack_public_path__ + "static/media/O_Oculos.c316a436.svg";